import Select, { ActionMeta, SingleValue } from 'react-select';
import { FilterOption } from '../../context/active-filter-context';

const desktop = {
  clearIndicator: (provided: any, state: any) => ({
    ...provided
  }),
  container: (provided: any, state: any) => ({
    ...provided
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: 'none !important',
    boxShadow: 'none',
    padding: '0',
    height: '38px',
    backgroundColor: 'transparent',
    '&:hover': {
      color: '#0077be'
    },
    color: state.isFocused ? '#0077be' : '#2b363b'
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    cursor: 'pointer',
    '& svg': {
      marginLeft: '1rem',
      width: 14,
      path: {
        fill: '#737680'
      }
    }
  }),
  group: (provided: any, state: any) => ({
    ...provided
  }),
  groupHeading: (provided: any, state: any) => ({
    ...provided
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    path: {
      fill: '#2b363b'
    }
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    display: 'none'
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    margin: '0',
    padding: '0',
    cursor: 'pointer'
  }),
  loadingIndicator: (provided: any, state: any) => ({
    ...provided
  }),
  loadingMessage: (provided: any, state: any) => ({
    ...provided
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #94999e',
    borderTop: '4px solid #0077be',
    borderRadius: '0',
    padding: '16px 0',
    width: 'auto',
    transform: 'translate(-20px, 8px)',
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.08)'
  }),
  menuList: (provided: any, state: any) => ({
    ...provided,
    border: 'none'
  }),
  menuPortal: (provided: any, state: any) => ({
    ...provided
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided
  }),
  multiValueLabel: (provided: any, state: any) => ({
    ...provided
  }),
  multiValueRemove: (provided: any, state: any) => ({
    ...provided
  }),
  noOptionsMessage: (provided: any, state: any) => ({
    ...provided
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#f6f7f9' : '#fff',
    backgroundImage: state.isSelected
      ? "url('data:image/webp;base64,UklGRvoAAABXRUJQVlA4WAoAAAAQAAAAGQAAGQAAQUxQSFYAAAABZ2AgksykT2Ab0ICIiFqXjnmAaW3tTb7QQYHtDFS3wGYAFkHio5igd8Yiv4uP6P8EQLmNQ1o9Si4YZYzwnzP4jyaZQgwFpFwEjyXD2Xcg8s+moIVqAVZQOCB+AAAAkAQAnQEqGgAaAD5lKI9FpCKhG/1UAEAGRLYAX6MQBvCwIDl9Su9oguhRpL4AAP74CW//9tkiKRVY4XOf5xHo67cO+//S+5+Za9R/cl/DR+iwKYFl2dsIRURLpyB+XqHtP9/PnV4DNf/oUGEvN0mhY6OLTt39RlJ797qyMmAA')"
      : 'none',
    backgroundPosition: '95% 5px',
    backgroundRepeat: 'no-repeat',
    color: '#2b363b',
    font: 'normal 400 14px "Roboto", Arial, Helvetica, sans-serif',
    padding: '10px 50px 10px 14px',
    width: '300px',
    cursor: 'pointer',

    '&:active': {
      backgroundColor: '#f6f7f9'
    },

    '@media (min-width: 720px)': {
      whiteSpace: 'nowrap',
      width: '100%'
    }
  }),
  placeholder: (provided: any, state: any) => ({
    ...provided
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    font: 'normal 700 16px "Roboto", Arial, Helvetica, sans-serif',
    margin: '0',
    padding: '0',
    color: 'inherit'
  }),
  valueContainer: (provided: any, state: any) => ({
    ...provided,
    padding: '0'
  })
};

const modal = {
  clearIndicator: (provided: any, state: any) => ({
    ...provided
  }),
  container: (provided: any, state: any) => ({
    ...provided
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: 'none !important',
    boxShadow: 'none',
    padding: '0'
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    display: 'none'
  }),
  group: (provided: any, state: any) => ({
    ...provided
  }),
  groupHeading: (provided: any, state: any) => ({
    ...provided
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    path: {
      fill: '#2b363b'
    }
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    display: 'none'
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    margin: '0',
    padding: '0'
  }),
  loadingIndicator: (provided: any, state: any) => ({
    ...provided
  }),
  loadingMessage: (provided: any, state: any) => ({
    ...provided
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    position: 'static',
    margin: 0,
    borderRadius: 0,
    border: 'none',
    boxShadow: 'none',
    height: '100vh'
  }),
  menuList: (provided: any, state: any) => ({
    ...provided,
    border: 'none',
    maxHeight: '100vh',
    height: '100%'
  }),
  menuPortal: (provided: any, state: any) => ({
    ...provided,
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh'
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided
  }),
  multiValueLabel: (provided: any, state: any) => ({
    ...provided
  }),
  multiValueRemove: (provided: any, state: any) => ({
    ...provided
  }),
  noOptionsMessage: (provided: any, state: any) => ({
    ...provided
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#f6f7f9' : '#fff',
    backgroundImage: state.isSelected
      ? "url('data:image/webp;base64,UklGRvoAAABXRUJQVlA4WAoAAAAQAAAAGQAAGQAAQUxQSFYAAAABZ2AgksykT2Ab0ICIiFqXjnmAaW3tTb7QQYHtDFS3wGYAFkHio5igd8Yiv4uP6P8EQLmNQ1o9Si4YZYzwnzP4jyaZQgwFpFwEjyXD2Xcg8s+moIVqAVZQOCB+AAAAkAQAnQEqGgAaAD5lKI9FpCKhG/1UAEAGRLYAX6MQBvCwIDl9Su9oguhRpL4AAP74CW//9tkiKRVY4XOf5xHo67cO+//S+5+Za9R/cl/DR+iwKYFl2dsIRURLpyB+XqHtP9/PnV4DNf/oUGEvN0mhY6OLTt39RlJ797qyMmAA')"
      : 'none',
    backgroundPosition: 'right 12px center',
    backgroundRepeat: 'no-repeat',
    color: '#2b363b',
    font: 'normal 400 14px "Roboto", Arial, Helvetica, sans-serif',
    padding: '10px 20px',
    cursor: 'pointer',
    maxWidth: '200px',
    '&:active': {
      backgroundColor: '#f6f7f9'
    }
  }),
  placeholder: (provided: any, state: any) => ({
    ...provided
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    font: 'normal 700 16px "Roboto", Arial, Helvetica, sans-serif',
    margin: '0',
    padding: '0',
    color: 'inherit'
  }),
  valueContainer: (provided: any, state: any) => ({
    ...provided,
    padding: '0'
  })
};

const customStyles = {
  desktop,
  modal
};

interface Props {
  dataTestId?: string;
  options: FilterOption[];
  value?: FilterOption;
  defaultOption: FilterOption;
  menuPortalTarget?: HTMLElement | null;
  menuIsOpen?: boolean;
  disabled?: boolean;
  styling?: 'desktop' | 'modal';
  onMenuOpen?: () => void;
  onChange: (newValue: SingleValue<FilterOption>, actionMeta: ActionMeta<FilterOption>) => void;
  name?: string;
}

const FilterSelect = ({
  dataTestId,
  options,
  value,
  onChange,
  onMenuOpen,
  menuPortalTarget = null,
  menuIsOpen,
  disabled = false,
  styling = 'desktop',
  name
}: Props) => {
  return (
    <Select
      data-testid={dataTestId}
      name={name}
      styles={customStyles[styling]}
      onChange={onChange}
      options={options}
      value={value}
      menuPortalTarget={menuPortalTarget}
      closeMenuOnSelect={styling === 'desktop'}
      closeMenuOnScroll={false}
      menuIsOpen={menuIsOpen}
      onMenuOpen={onMenuOpen}
      isDisabled={disabled}
    />
  );
};

export default FilterSelect;
